import { Link } from "react-router-dom";
import { Home, SearchX } from "lucide-react";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="mx-auto max-w-md px-6 py-24 text-center">
      <Seo title="Page Not Found | Divine Kids Learning" description="This page could not be found." />
      <div className="rounded-[2rem] bg-white p-10 shadow-xl shadow-blue-900/5">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-sky-100">
          <SearchX className="h-8 w-8 text-brand-blue" />
        </div>
        <h1 className="mt-5 font-display text-3xl font-bold text-slate-800">Page not found</h1>
        <p className="mt-3 font-semibold text-slate-500">
          This page seems to have wandered off to play. Let's get you back home.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-button"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand-blue px-8 py-3 font-display text-lg font-bold text-white shadow-[0_5px_0_0_#1D4ED8] active:translate-y-1 active:shadow-none"
        >
          <Home className="h-5 w-5" /> Back to Home
        </Link>
      </div>
    </div>
  );
}
